import { render, staticRenderFns } from "./SeparatorComponent.vue?vue&type=template&id=330a6b35&scoped=true"
import script from "./SeparatorComponent.vue?vue&type=script&lang=js"
export * from "./SeparatorComponent.vue?vue&type=script&lang=js"
import style0 from "./SeparatorComponent.vue?vue&type=style&index=0&id=330a6b35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330a6b35",
  null
  
)

export default component.exports